import * as React from "react";
import * as _ from "underscore";

import { connect } from "react-redux";
import * as moment from "moment";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { AppShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import { getFileDownloadBaseURL } from "config";
import LabeledInput from "web_modules/LabeledInput";
import DocDisplay from "underwriter_dashboard/shared/DocDisplay";

import { DocumentUploader } from "web_modules/DocumentUploader";
import APIClient from "web_modules/APIClient";
import Money from "web_modules/Money";
import { loadApp } from "underwriter_dashboard/actions";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";
import ReggoraWorkflowSection from "./ReggoraWorkflow";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");
const { FormGroup, ControlLabel } = require("react-bootstrap");
const { Table } = require("react-bootstrap");

const mapUnderwriterStateToProps = (state, ownProps) => ({
  documents: ownProps.documents,
  documentType: ownProps.documentType,
  prompt: ownProps.prompt,
  onUpload: ownProps.onUpload,
  ownerEntityType: ownProps.ownerEntityType,
  ownerEntityID: ownProps.ownerEntityID,
  applicationID: ownProps.applicationID,
});

const mapUnderwriterDispatchToProps = dispatch => ({
  updateApplication: (dispatchType, payload) => {
    loadApp(dispatch, payload.id);
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

export class AppraisalReportHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);

    const { app } = props;
    const { appraisal, contacts } = app;
    const { appraiser, appraiser_company, appraisal_inspection_contact } = contacts;

    this.state = {
      appraised_value: (appraisal && appraisal.appraised_value) || "",
      appraised_market_rent_unit1: (appraisal && appraisal.appraised_market_rent_unit1) || "",
      appraised_market_rent_unit2: (appraisal && appraisal.appraised_market_rent_unit2) || "",
      appraised_market_rent_unit3: (appraisal && appraisal.appraised_market_rent_unit3) || "",
      appraised_market_rent_unit4: (appraisal && appraisal.appraised_market_rent_unit4) || "",
      year_built: (appraisal && appraisal.year_built) || "",
      id: appraisal && appraisal.id,
      inspection_date: appraisal && appraisal.inspection_date,
      effective_date: appraisal && appraisal.effective_date,
      requested_date: appraisal && appraisal.requested_date,
      due_back_date: appraisal && appraisal.due_back_date,
      order_accepted_date: appraisal && appraisal.order_accepted_date,
      received_date: appraisal && appraisal.received_date,
      inspection_scheduled_date: appraisal && appraisal.inspection_scheduled_date,
      inspection_completed_date: appraisal && appraisal.inspection_completed_date,
      expected_date: appraisal && appraisal.expected_date,
      approved_date: appraisal && appraisal.approved_date,
      vendor: (appraisal && appraisal.vendor) || "",
      latest_event_status: (appraisal && appraisal.latest_event_status) || "",
      latest_event_type: (appraisal && appraisal.latest_event_type) || "",
      attachment_type: (appraisal && appraisal.attachment_type) || "",
      living_unit_count: (appraisal && appraisal.living_unit_count) || "",
      pud: (appraisal && appraisal.pud) || "",
      project_classification_type: (appraisal && appraisal.project_classification_type) || "",
      project_name: (appraisal && appraisal.project_name) || "",
      property_category_type: (appraisal && appraisal.property_category_type) || "",
      appraised_address_line1: (appraisal && appraisal.appraised_address_line1) || "",
      appraised_address_line2: (appraisal && appraisal.appraised_address_line2) || "",
      appraised_address_city: (appraisal && appraisal.appraised_address_city) || "",
      appraised_address_state: (appraisal && appraisal.appraised_address_state) || "",
      appraised_address_postal_code: (appraisal && appraisal.appraised_address_postal_code) || "",
      property_type_computed: (appraisal && appraisal.property_type_computed) || "",
      showLSAM: false,
      appraiser_contact_name: appraiser ? appraiser.name : "",
      appraiser_contact_state_license: appraiser ? appraiser.state_license : "",
      appraiser_company_name: appraiser_company ? appraiser_company.name : "",
      appraisal_contact_name: appraisal_inspection_contact ? appraisal_inspection_contact.name : "",
      appraisal_contact_phone: appraisal_inspection_contact
        ? appraisal_inspection_contact.phone
        : "",
      appraisal_contact_email: appraisal_inspection_contact
        ? appraisal_inspection_contact.email
        : "",
    };

    this.createAppraisalRecord = this.createAppraisalRecord.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSelectOnChange = this.handleSelectOnChange.bind(this);

    this.requestLSAM = this.requestLSAM.bind(this);
    this.checkLSAM = this.checkLSAM.bind(this);
    this.toggleLSAM = this.toggleLSAM.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const { app } = this.props;
    const appraisalData = app.appraisal;
    const appraisalDocuments = this.getAppraisalDocuments();

    if (!appraisalData && appraisalDocuments.length > 0) {
      this.createAppraisalRecord(appraisalDocuments[0].id);
    } else if (!appraisalData) {
      this.createAppraisalRecord(null);
    }
  }

  prepareStateForAPI = (v: any) => {
    const values = { ...v };

    values.appraised_value = values.appraised_value
      ? parseFloat(values.appraised_value.replace(/,/g, ""))
      : 0;
    values.appraised_market_rent_unit1 = values.appraised_market_rent_unit1
      ? parseFloat(values.appraised_market_rent_unit1.replace(/,/g, ""))
      : 0;
    values.appraised_market_rent_unit2 = values.appraised_market_rent_unit2
      ? parseFloat(values.appraised_market_rent_unit2.replace(/,/g, ""))
      : 0;
    values.appraised_market_rent_unit3 = values.appraised_market_rent_unit3
      ? parseFloat(values.appraised_market_rent_unit3.replace(/,/g, ""))
      : 0;
    values.appraised_market_rent_unit4 = values.appraised_market_rent_unit4
      ? parseFloat(values.appraised_market_rent_unit4.replace(/,/g, ""))
      : 0;
    values.year_built = values.year_built ? parseInt(values.year_built, 10) : 0;
    values.living_unit_count = values.living_unit_count
      ? parseInt(values.living_unit_count, 10)
      : 0;
    // dates are pointers in the api
    values.requested_date = values.requested_date || null;
    values.expected_date = values.expected_date || null;
    values.approved_date = values.approved_date || null;
    values.inspection_date = values.inspection_date || null;
    values.effective_date = values.effective_date || null;
    values.due_back_date = values.due_back_date || null;
    values.order_accepted_date = values.order_accepted_date || null;
    values.inspection_scheduled_date = values.inspection_scheduled_date || null;
    values.inspection_completed_date = values.inspection_completed_date || null;
    values.received_date = values.received_date || null;

    return values;
  };

  onSave() {
    const { dispatch, app } = this.props;
    const { contacts } = app;
    const { appraiser, appraiser_company, appraisal_inspection_contact } = contacts;
    const valuesClone: any = this.prepareStateForAPI(this.state);

    const contactInfoUpdates = [];
    if (valuesClone.appraiser_contact_name || valuesClone.appraiser_contact_state_license) {
      const updatedContact = {
        ...appraiser,
        name: valuesClone.appraiser_contact_name,
        state_license: valuesClone.appraiser_contact_state_license,
        role: "Appraiser",
        source: "AppraisalResponseMISMO",
        loan_application_id: app.id,
      };
      const appraiserUpdate = APIClient.post(`/contacts`, updatedContact);
      contactInfoUpdates.push(appraiserUpdate);
    }
    if (valuesClone.appraiser_company_name) {
      const updatedContact = {
        ...appraiser_company,
        name: valuesClone.appraiser_company_name,
        role: "AppraiserCompany",
        source: "AppraisalResponseMISMO",
        loan_application_id: app.id,
      };
      const appraiserCompanyUpdate = APIClient.post(`/contacts`, updatedContact);
      contactInfoUpdates.push(appraiserCompanyUpdate);
    }
    if (valuesClone.appraisal_contact_name) {
      const updatedContact = {
        ...appraisal_inspection_contact,
        name: valuesClone.appraisal_contact_name,
        phone: valuesClone.appraisal_contact_phone,
        email: valuesClone.appraisal_contact_email,
        role: "AppraisalInspectionContact",
        source: "ContactInfoHurdle",
        loan_application_id: app.id,
      };
      const appraisalInspectionContactUpdate = APIClient.post(`/contacts`, updatedContact);
      contactInfoUpdates.push(appraisalInspectionContactUpdate);
    }

    // update appraisal record
    if (valuesClone.id) {
      const appraisalUpdate = APIClient.put(`/uw/${app.id}/appraisals`, valuesClone);
      contactInfoUpdates.push(appraisalUpdate);
    }
    if (contactInfoUpdates.length > 0) {
      Promise.all(contactInfoUpdates)
        .then(() => {
          loadApp(dispatch, app.id);
        })
        .catch(err => {
          alert(`Error! Couldn't save! \n\n${err.meta && err.meta.error_detail}`);
        });
    }
  }

  // TODO (mike) LabeledInput should have readOnly prop (see property_type_computed below)
  renderInputs() {
    const {
      appraised_value,

      // NOTE: jjw: part of state but unpacked programmatically below
      // appraised_market_rent_unit1,
      // appraised_market_rent_unit2,
      // appraised_market_rent_unit3,
      // appraised_market_rent_unit4,

      year_built,
      inspection_date,
      effective_date,
      due_back_date,
      order_accepted_date,
      inspection_scheduled_date,
      inspection_completed_date,
      requested_date,
      expected_date,
      approved_date,
      received_date,
      vendor,
      attachment_type,
      living_unit_count,
      pud,
      project_classification_type,
      project_name,
      property_category_type,
      appraised_address_line1,
      appraised_address_line2,
      appraised_address_city,
      appraised_address_state,
      appraised_address_postal_code,
      property_type_computed,
      appraiser_contact_name,
      appraiser_contact_state_license,
      appraiser_company_name,
      appraisal_contact_name,
      appraisal_contact_phone,
      appraisal_contact_email,
    } = this.state;

    const pud_options = [
      { label: "Yes", value: "y" },
      { label: "No", value: "n" },
    ];

    return (
      <div className="appraisal_report_inputs">
        <div className={styles.appraisalReportGrid}>
          <div>
            <h4>Inspection Contact</h4>
            <LabeledInput
              placeholder="first & last name"
              labelValue="Appraisal Contact Name"
              inputType="text"
              inputName="appraisal_contact_name"
              inputValue={appraisal_contact_name || ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="555-555-5555"
              labelValue="Appraisal Contact Phone"
              inputType="text"
              inputName="appraisal_contact_phone"
              inputValue={appraisal_contact_phone || ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="email@email.com"
              labelValue="Appraisal Contact Email"
              inputType="text"
              inputName="appraisal_contact_email"
              inputValue={appraisal_contact_email || ""}
              onChange={this.handleOnChange}
            />
            <h4>Appraiser</h4>
            <LabeledInput
              placeholder="appraiser name"
              labelValue="Appraiser Contact Name"
              inputType="text"
              inputName="appraiser_contact_name"
              inputValue={appraiser_contact_name || ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="state license"
              labelValue="Appraiser Contact State License"
              inputType="text"
              inputName="appraiser_contact_state_license"
              inputValue={appraiser_contact_state_license || ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="company name"
              labelValue="Appraiser Company Name"
              inputType="text"
              inputName="appraiser_company_name"
              inputValue={appraiser_company_name || ""}
              onChange={this.handleOnChange}
            />
          </div>
          <div>
            <h4>Appraisal Dates</h4>
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Date Appraisal Requested"
              hint="The date we placed the appraisal order"
              inputType="date"
              inputName="requested_date"
              inputValue={requested_date ? moment.utc(requested_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Appraisal requested due date"
              hint="The date we asked the appraisal to be back by"
              inputType="date"
              inputName="due_back_date"
              inputValue={due_back_date ? moment.utc(due_back_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Date Appraisal Expected"
              hint="The current due date in reggora."
              inputType="date"
              inputName="expected_date"
              inputValue={expected_date ? moment.utc(expected_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Order Accepted Date"
              hint="The date the AMC accepted the order"
              inputType="date"
              inputName="order_accepted_date"
              inputValue={
                order_accepted_date ? moment.utc(order_accepted_date).format("YYYY-MM-DD") : ""
              }
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Received Date"
              hint="The date the Original Appraisal Report Received"
              inputType="date"
              inputName="received_date"
              inputValue={received_date ? moment.utc(received_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
          </div>
        </div>
        <div className={styles.appraisalReportGrid}>
          <div>
            <h4>Inspection Dates</h4>
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Inspection scheduled date"
              hint="The date the AMC scheduled an inspection"
              inputType="date"
              inputName="inspection_scheduled_date"
              inputValue={
                inspection_scheduled_date
                  ? moment.utc(inspection_scheduled_date).format("YYYY-MM-DD")
                  : ""
              }
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Inspection Date"
              hint="The date the inspections is scheduled to occur"
              inputType="date"
              inputName="inspection_date"
              inputValue={inspection_date ? moment.utc(inspection_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Inspection completion date"
              hint="The date the inspection was completed"
              inputType="date"
              inputName="inspection_completed_date"
              inputValue={
                inspection_completed_date
                  ? moment.utc(inspection_completed_date).format("YYYY-MM-DD")
                  : ""
              }
              onChange={this.handleOnChange}
            />
          </div>
          <div>
            <h4>Misc Dates</h4>
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Effective Date"
              hint="this is the “as of” date from the report that the LM enters"
              inputType="date"
              inputName="effective_date"
              inputValue={effective_date ? moment.utc(effective_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              placeholder="yyyy-mm-dd"
              labelValue="Date Appraisal Approved"
              hint="UW reviews the report and send to borrower"
              inputType="date"
              inputName="approved_date"
              inputValue={approved_date ? moment.utc(approved_date).format("YYYY-MM-DD") : ""}
              onChange={this.handleOnChange}
            />
          </div>
        </div>
        <div className={styles.appraisalReportGrid}>
          <div>
            <h4>Appraisal Information</h4>
            <LabeledInput
              labelValue="Appraised Value"
              inputType="money"
              inputName="appraised_value"
              inputValue={appraised_value}
              onChange={this.handleOnChange}
            />
            {[
              "appraised_market_rent_unit1",
              "appraised_market_rent_unit2",
              "appraised_market_rent_unit3",
              "appraised_market_rent_unit4",
            ].map((fieldName, idx) => (
              <LabeledInput
                labelValue={`Appraised Market Rent (Unit ${idx + 1})`}
                inputType="money"
                inputName={fieldName}
                inputValue={this.state[fieldName]}
                onChange={this.handleOnChange}
              />
            ))}
            <LabeledInput
              labelValue="Year Built"
              inputType="text"
              inputName="year_built"
              inputValue={year_built}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Vendor"
              inputType="text"
              inputName="vendor"
              inputValue={vendor}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Attachment Type"
              inputType="text"
              inputName="attachment_type"
              inputValue={attachment_type}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Living Unit Count"
              inputType="text"
              inputName="living_unit_count"
              inputValue={living_unit_count}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="PUD"
              inputType="select"
              inputName="pud"
              inputValue={pud}
              options={pud_options}
              onChange={val => {
                this.handleSelectOnChange("pud", val);
              }}
            />
            <LabeledInput
              labelValue="Project Classification Type"
              inputType="text"
              inputName="project_classification_type"
              inputValue={project_classification_type}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Project Name (HOA/PUD/Neighborhood)"
              inputType="text"
              inputName="project_name"
              inputValue={project_name}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Property Category Type"
              inputType="text"
              inputName="property_category_type"
              inputValue={property_category_type}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Appraised Address Line1"
              inputType="text"
              inputName="appraised_address_line1"
              inputValue={appraised_address_line1}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Appraised Address Line2"
              inputType="text"
              inputName="appraised_address_line2"
              inputValue={appraised_address_line2}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Appraised Address City"
              inputType="text"
              inputName="appraised_address_city"
              inputValue={appraised_address_city}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Appraised Address State"
              inputType="text"
              inputName="appraised_address_state"
              inputValue={appraised_address_state}
              onChange={this.handleOnChange}
            />
            <LabeledInput
              labelValue="Appraised Address Postal Code"
              inputType="text"
              inputName="appraised_address_postal_code"
              inputValue={appraised_address_postal_code}
              onChange={this.handleOnChange}
            />
          </div>
        </div>
        <div style={{ padding: "1rem" }}>
          <FormGroup>
            <ControlLabel>Property Type Computed</ControlLabel>
            <input className="form-control" type="text" value={property_type_computed} readOnly />
          </FormGroup>
        </div>

        <div style={{ marginBottom: "50px" }} />
      </div>
    );
  }

  requestAppraisalFrom(provider: string) {
    const {
      app: { id },
      dispatch,
    } = this.props;
    APIClient.post(`/${id}/appraisal`, { provider })
      .then((response: any) => {
        if (response.status === "in_progress") {
          this.setState(
            () => ({
              [`requested_date`]: new Date(),
              [`appraisalOrderedAt`]: new Date().toUTCString(),
            }),
            this.onSave,
          );
          loadApp(dispatch, id);
        } else {
          this.setState({
            [`errorMessage`]: "Problem ordering appraisal.",
          });
        }
      })
      .catch((err: any) => {
        alert(err.meta && err.meta.error_detail);
        this.setState({
          [`errorMessage`]: "Problem ordering appraisal.",
        });
      });
  }

  markAppraisalOrdered = () => {
    const { app, dispatch } = this.props;

    const appraisal = { ...this.state };

    const changes = {
      [`requested_date`]: new Date(),
      [`appraisalOrderedAt`]: new Date().toUTCString(),
    };

    this.setState(changes);

    const stateForAPI = this.prepareStateForAPI({ ...appraisal, ...changes });

    const promises = [
      //  TODO: handle this appraisal_ordered update
      APIClient.put(`/loan_applications/${app.id}`, { appraisal_ordered: true }),
      APIClient.put(`/uw/${app.id}/appraisals`, stateForAPI),
    ];

    Promise.all(promises).then(() => {
      loadApp(dispatch, app.id);
    });
  };

  requestLSAM() {
    const {
      app: { id },
    } = this.props;
    this.setState({
      [`lsamCheckedAt`]: new Date().toUTCString(),
    });
    APIClient.post(`/${id}/lsam`, {}).then((response: any) => {
      if (response.status !== "in_progress") {
        this.setState({
          [`errorMessage`]: "Problem ordering LSAM.",
        });
      }
    });
  }

  checkLSAM() {
    const {
      dispatch,
      app: { id },
    } = this.props;
    this.setState({
      [`lsamCheckedAt`]: new Date().toUTCString(),
    });
    loadApp(dispatch, id);
  }

  renderWorkflowButton(appraisalDoc, lsamDoc) {
    const {
      app: { id, purchased_property_received_date },
    } = this.props;
    const {
      appraisalOrderedAt,
      errorMessage,
      lsamCheckedAt,
      latest_event_type,
      latest_event_status,
    } = this.state;
    if (errorMessage) {
      return <p>{errorMessage}</p>;
    }
    if (!appraisalDoc) {
      if (!appraisalOrderedAt) {
        return (
          <div>
            <br />
            <span>
              <ReggoraWorkflowSection
                loanAppID={id}
                respaDate={purchased_property_received_date}
                latestEventType={latest_event_type}
                latestEventStatus={latest_event_status}
              />
            </span>
          </div>
        );
      }
      return <p>Appraisal ordered at {appraisalOrderedAt}.</p>;
    }
    if (!lsamDoc) {
      if (!lsamCheckedAt) {
        return (
          <Button size="small" onClick={this.requestLSAM}>
            Request LoanSafe Appraisal Manager report
          </Button>
        );
      }
      return (
        <div>
          <Button size="small" onClick={this.checkLSAM}>
            Check LSAM status
          </Button>
          <p>Checked at: {lsamCheckedAt}</p>
        </div>
      );
    }

    return null;
  }

  // @pastormt this instead of getDoc so that appraisal document.id matches
  // app.appraisal.document_id regardless of backend implementation resolving
  // appraisal priority
  getAppraisal(id) {
    const {
      app: { documents },
    } = this.props;
    return _.find(documents, (d: any) => d.id === id);
  }

  getDoc(documentType) {
    const {
      app: { documents },
    } = this.props;
    return _.chain(documents)
      .filter((d: any) => d.type === documentType)
      .sortBy((d: any) => -1 * parseInt(d.id, 10)) // most recently uploaded doc is displayed.
      .first()
      .value();
  }

  handleOnChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleSelectOnChange(name, option) {
    this.setState({ [name]: option.value });
  }

  toggleLSAM() {
    this.setState(prevState => {
      return { showLSAM: !prevState.showLSAM };
    });
  }

  static renderLSAMAlerts(alerts) {
    return (
      <Table condensed bordered striped hover>
        <thead>
          <tr>
            <th>Alert ID</th>
            <th>Classification</th>
            <th>Message</th>
            <th>Recommendation</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map(alert => (
            <tr key={alert.external_id}>
              <td>{alert.external_id}</td>
              <td>{alert.classification}</td>
              <td>{alert.message}</td>
              <td>{alert.recommendation}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  renderLSAMData() {
    const {
      app: { lsam_summary },
    } = this.props;
    if (lsam_summary) {
      return (
        <div>
          {lsam_summary.high_severity_alerts && (
            <div>
              <h4>High Severity Alerts:</h4>
              {AppraisalReportHurdleEditor.renderLSAMAlerts(lsam_summary.high_severity_alerts)}
            </div>
          )}
          {lsam_summary.medium_severity_alerts && (
            <div>
              <h4>Medium Severity Alerts:</h4>
              {AppraisalReportHurdleEditor.renderLSAMAlerts(lsam_summary.medium_severity_alerts)}
            </div>
          )}
        </div>
      );
    }
    return null;
  }

  createAppraisalRecord(document_id) {
    const { app, dispatch } = this.props;

    APIClient.post(`/uw/${app.id}/appraisals`, { document_id }).then(() => {
      loadApp(dispatch, app.id);
    });
  }

  getAppraisalDocuments() {
    const { app } = this.props;

    const { documents } = app;
    return documents.filter(d => d.type === DocTypes.AppraisalReport);
  }

  renderContent() {
    const { app } = this.props;
    const appraisalData = app.appraisal;

    const appraisal: any =
      appraisalData && appraisalData.document_id && this.getAppraisal(appraisalData.document_id);
    const lsam: any = this.getDoc(DocTypes.LoansafeAppraisalManagerReport);

    const { documents } = app;
    const appraisals = documents.filter(d => d.type === DocTypes.AppraisalReport);

    const { showLSAM } = this.state;

    return (
      <div>
        {this.renderWorkflowButton(appraisal, lsam)}
        <br />
        <br />
        {app.purchased_property_avm && (
          <div>
            AVM: <Money value={parseFloat(app.purchased_property_avm)} />
          </div>
        )}
        {appraisals && (
          <div style={{ display: "flex", flexFlow: "row nowrap" }}>
            <div style={{ width: "60%" }}>
              <DocDisplay docs={appraisals} />
            </div>
            <div style={{ width: "40%", overflowY: "scroll", height: "100%" }}>
              {this.renderInputs()}
            </div>
          </div>
        )}
        {lsam && (
          <h4>
            <Button onClick={this.toggleLSAM}>LoanSafe Appraisal Manager report</Button>
          </h4>
        )}
        {lsam && showLSAM && (
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ flex: 3 }}>
              <iframe
                title="lsam"
                src={getFileDownloadBaseURL(lsam.s3_key)}
                width="100%"
                height="520"
              />
            </div>
          </div>
        )}
        {lsam && this.renderLSAMData()}
        {!appraisal && (
          <div>
            <p>
              Please order an appraisal through the button above. Otherwise, you may upload it
              below, but keep in mind LSAM cannot be ordered for uploaded appraisals.
            </p>
            <UnderwriterDocumentUploader
              applicationID={app.id}
              documents={app.documents}
              documentType={DocTypes.AppraisalReport}
              prompt="Upload Appraisal Report"
              onUpload={this.createAppraisalRecord}
            />
          </div>
        )}
      </div>
    );
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {this.renderContent()}
        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button kind="primary" onClick={this.onSave} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default connect()(AppraisalReportHurdleEditor);
